<template>
  <v-container>
    <v-row
      justify="end"
      align-content="end"
    >
      <v-col>
        <v-btn
          rounded
          dense
          small
          class="float-right"
          color="primary"
          @click="$emit('toggle-edit')"
          :disabled="!canUserEdit"
        >
          <v-icon> mdi-pencil </v-icon>
          {{ $t('common.edit') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col>
                <small><b> {{ $t('contract.name') }} </b> </small>
                <p>{{contract.contractName}}</p>
              </v-col>
              <v-col>
                <small><b> {{ $tc(`contract.project.${contract.areaCode}`, 1) }} </b> </small>
                <p>{{contract.project ? contract.project.name : ''}}</p>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <small> <b>{{ $t('contract.signedPrice') }}</b> </small>
                <p>{{ signedPriceCents | formatCurrency(contract.chosenCurrency)}}</p>
              </v-col>
              <v-col>
                <small> <b>{{ $t('contract.adjustedPrice') }}</b> </small>
                <InfoTooltip
                  :text="$t('contract.adjustedPriceTip')"
                />
                <p>
                  {{ adjustedPriceCents | formatCurrency(contract.chosenCurrency)}}
                  {{ $t('contract.percentOfSignedPrice', { percent: adjustedPricePercent }) }}
                </p>
              </v-col>
              <v-col>

                <small> <b>{{ $t('contract.forecastedPrice') }}</b> </small>
                <InfoTooltip
                  :text="$t('contract.forecastedPriceTip')"
                />
                <p>
                  {{ forecastedPriceCents | formatCurrency(contract.chosenCurrency)}}
                  {{ $t('contract.percentOfSignedPrice', { percent: forecastedPricePercent }) }}
                </p>
              </v-col>
              <v-col>
                <small> <b>{{ $t('contract.alreadyPaid') }}</b> </small>
                <p>{{ currentPriceCents | formatCurrency(contract.chosenCurrency)}} ({{ currentPercent }}%)</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        v-for="(subContract, index) in contract.subContracts"
        :key="index"
      >
        <v-card>
          <SubContractInfo :contract="subContract" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContractInfoMixin from '@/mixins/ContractInfoMixin'

export default {
  name: 'ParentContractInfo',
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  mixins: [ContractInfoMixin],
  data () {
    return { }
  },
  methods: { }
}
</script>

<style>
.purchase-order {
  margin: 5px 0!important;
}
</style>
